import { BrandConfig } from '../types';

export const entainConfig: BrandConfig = {
  id: 'entain',
  name: 'Entain',
  displayName: 'Entain',
  logo: 'Entain.svg',
  primaryColor: '#bf00ff',
  categories: [
    {
      name: 'Entain Games',
      banner: 'banners/banner_Entain.jpg',
      gamesPath: 'brands/entain.json',
      brandIcon: 'logo_entain.png',
      comingSoon: false,
      disabled: false
    }
  ],
  defaultBanners: [
    'banners/banner_Entain.jpg',
  ]
};
